// List of hazards for the tool
// To add, edit, or remove available hazard options for the tool just change this list
// Be sure to also alter the themeGroupings above with any changes

// IDs 2000-2999 will be interpretted as options within the app
// IDs 4000-4999 will be interpretted as external links and will require a url. When selected they open a new tab but do not change any app state
export const hazardAttrs = [
  { id: 2000, name: 'Blizzard', themes: [8] },
  { id: 2001, name: 'Coastal Flood', themes: [0, 1] },
  { id: 2002, name: 'Cold/Wind Chill', themes: [8] },
  { id: 2003, name: 'Dense Fog', themes: [2] },
  { id: 2004, name: 'Excessive Heat', themes: [6] },
  { id: 2005, name: 'Extreme Cold/Wind Chill', themes: [8] },
  { id: 2006, name: 'Flash Flood', themes: [1, 4] },
  { id: 2007, name: 'Flood', themes: [1] },
  { id: 2008, name: 'Frost/Freeze', themes: [8] },
  { id: 2009, name: 'Hail', themes: [4] },
  { id: 2010, name: 'Heat', themes: [6] },
  { id: 2011, name: 'Heavy Rain', themes: [1, 4] },
  { id: 2012, name: 'Heavy Snow', themes: [8] },
  { id: 2013, name: 'High Surf', themes: [0] },
  { id: 2014, name: 'High Wind', themes: [4] },
  { id: 2015, name: 'Hurricane', themes: [5] },
  { id: 2016, name: 'Ice Storm', themes: [8] },
  { id: 2017, name: 'Lake-Effect Snow', themes: [3] },
  { id: 2018, name: 'Lakeshore Flood', themes: [1, 3] },
  { id: 2019, name: 'Rip Current', themes: [0] },
  { id: 2020, name: 'Sleet', themes: [8] },
  { id: 2021, name: 'Storm Surge/Tide', themes: [0] },
  { id: 2022, name: 'Strong Wind', themes: [4] },
  { id: 2023, name: 'Thunderstorm Wind', themes: [4] },
  { id: 2024, name: 'Tornado', themes: [4] },
  { id: 2025, name: 'Tropical Storm', themes: [5] },
  { id: 2026, name: 'Wildfire', themes: [7] },
  { id: 2027, name: 'Winter Storm', themes: [8] },
  { id: 2028, name: 'Winter Weather', themes: [8] }
];

export const hazardMetrics = [
  {
    name: 'count',
    text: 'Total Reported Episodes',
  },
  {
    name: 'damageCrops',
    text: 'Reported Crop Damage',
  },
  {
    name: 'damageProperty',
    text: 'Reported Property Damage',
  },
  {
    name: 'deaths',
    text: 'Total Reported Deaths',
  },
  {
    name: 'injuries',
    text: 'Total Reported Injuries',
  },
];

export const selectHazardAttrById = (id) => {
  return hazardAttrs.find((attr) => attr.id === id);
};
